module.exports = __webpack_public_path__ + "static/media/enfant-present.a0c0337c.svg";